import { useHits, useSearchBox } from 'react-instantsearch';
import type { SearchHit } from '../search/search-hit-types';

/*
    Adapted from
    https://www.algolia.com/doc/guides/sending-events/connectors/segment/#augment-your-segment-events-with-algolia-related-data
    React InstantSearch tab in example
    Send hit view to Segment, which will forward it to Algolia as "Product Viewed" event
*/
interface DebouncedHitsArgs {
    hits: SearchHit[];
    query: string;
}

const debounce = (fn: (args: DebouncedHitsArgs) => void, delay: number) => {
    let timerId: ReturnType<typeof setTimeout> | null;
    return function (...args: [DebouncedHitsArgs]) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            fn(args[0]);
            timerId = null;
        }, delay);
    };
};

const debouncedHitsRender = debounce(({ hits, query }) => {
    if (hits && hits.length > 0 && query && query.length > 0) {
        if (window.dataLayer) {
            console.log('algolia hits viewed to gtm');
            window.dataLayer.push({ event: 'Hits Viewed' });
        }
    }
}, 500);

export const SearchHitsViewed = () => {
    const { hits } = useHits<SearchHit>();
    const { query } = useSearchBox();

    debouncedHitsRender({ hits, query });
    return null;
};

export default SearchHitsViewed;
